import {createContext} from 'react';

export type User = {
  emailAddress: string,
  name: string,
  picture: string
};

type Props = {
  signIn: (user: User, token: string) => void,
  signOut: () => void,
  secondsRemainingInSession: number,
  user: User|undefined,
  apiToken: string|undefined
}

const UserContext = createContext<Props>({
  signIn: async () => {
    console.log('UserContext.signIn called before being set');
  },
  signOut: () => {
    console.log('UserContext.signOut called before being set');
  },
  secondsRemainingInSession: 0,
  user: undefined,
  apiToken: undefined
});
export default UserContext;

export function userEmail(user: User|undefined): string {
  return user?.emailAddress || '{unknown}';
}

export function splitName(user: User|undefined): string[] {
  const name = user?.name || '{unknown}';
  const parts = name.split(' ');
  return parts.length === 1
    ? [parts[0], '']
    : parts;
}
